import { Button, Form, Input, notification } from 'antd';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Loader from '../../../Components/Loader/Loader';
import { showErrorNotification, showInfoNotification } from '../../../Services/Notifications';
import { headers } from '../../../Utils/utils';
import '.././UploadDocument.scss';
// import ManipulateDo÷cumentRows from "./ManipulateDocumentRows";
notification.config({ maxCount: 1 });

const UploadDocumentForm = () => {
  const navigate = useNavigate();

  const [file, setFile] = useState([]);
  const [disabled, setDisabled] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [objectData, setObjectData] = useState([]);
  const [esignDocumentStatus, setEsignDocumentStatus] = useState('Ready');
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [selectTypeValue, setSelectTypeValue] = useState('');
  const [selectTypeText, setSelectTypeText] = useState('');
  const [inputTypeValue, setInputTypeValue] = useState('');
  const [quality, setQuality] = useState('medium');

  const handleRemoveFile = (index) => {
    const updatedTableData = [...uploadedFiles];
    updatedTableData.splice(index, 1);
    console.log(updatedTableData, '....,.,.,');
    setUploadedFiles(updatedTableData);
    // Update the selected files in the input field
    const remainingFiles = Object.values(file).filter((_, i) => i !== index);
    setFile(remainingFiles);
  };

  const handleFileChange = (event) => {
    //console.log(".............");
    let selectedFile = event.target.files;
    //console.log("selectedFile", selectedFile, Object.keys(selectedFile));
    let noImgMsg;
    let msg = 'Allowed extensions are pdf, jpg, jpeg and png.';
    let allowedExtensions = ['image/png', 'image/jpeg', 'image/jpg', 'application/pdf'];
    //console.log(selectedFile, ".......");
    if (selectedFile && Object.keys(selectedFile).length) {
      let notImage = Object.keys(selectedFile).find((item) => {
        let fileType = selectedFile[item].type.toLowerCase();
        console.log('Checking file type:', fileType);
        if (!allowedExtensions.includes(fileType)) {
          //console.log("File type not allowed:", fileType);
          return true; // Return true to indicate that this file is not allowed
        }
        return false; // Return false to indicate that this file is allowed
      });
      if (typeof notImage !== 'undefined') noImgMsg = msg;
    } else noImgMsg = msg;
    if (noImgMsg) {
      setDisabled(true);
      showInfoNotification(noImgMsg);
    } else {
      setDisabled(false);
      setFile((files) => {
        //console.log(selectedFile, files, "/...../");
        let allFileNames = uploadedFiles.join(' ');
        selectedFile = Object.values(selectedFile).filter((file) => {
          if (!allFileNames.includes(file.name)) {
            return true;
          } else {
            showErrorNotification(`${file.name} is already uplaoded.`);
            return false;
          }
        });
        selectedFile = [...selectedFile, ...files];
        const fileNames = Object.values(selectedFile).map((file) => file.name);
        //console.log("selectedFile.length = ", selectedFile.length, "......");
        setUploadedFiles(fileNames);
        return selectedFile;
      });
    }
    //console.log("Called");
  };

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    mobile: '',
  });

  const handleKeyPress = (event) => {
    // Prevent typing special characters
    const { name, value } = event.target;
    const key = event.key;
    let allowedCharacters = /^[a-zA-Z0-9\s]*$/; // Regular expression for alphanumeric characters and space
    if (name == 'name') {
      allowedCharacters = /^[a-zA-Z\s]*$/;
    }
    if (name == 'email' || name == 'lead_number') {
      allowedCharacters = /^[a-zA-Z0-9@.-]+$/;
    }
    if (name == 'mobile') {
      allowedCharacters = /^[0-9\b]+$/;
    }
    console.log(key);
    if (!allowedCharacters.test(key) && key !== 'Backspace' && key !== 'Delete') {
      event.preventDefault();
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const uploadData = (filesData, objectData) => {
    setDisabled(true);
    //console.log(filesData);
    const formData = new FormData();
    Object.values(filesData).map((file, key) => {
      formData.append('file' + key, file);
    });
    formData.append('quality', quality);
    let otherData = {};
    otherData.name = objectData.name;
    otherData.email = objectData.email;
    otherData.mobile = objectData.mobile;
    let obj = {};
    if (objectData.lead_number) {
      obj[selectTypeValue] = objectData.lead_number;
    }
    otherData.transaction_key_value = JSON.stringify(obj);
    let dataHeaders = headers();
    delete dataHeaders['Content-Type'];

    otherData = { ...dataHeaders, ...otherData };
    // console.log("otherData", otherData);
    fetch(process.env.REACT_APP_BACKEND_HOST + 'services/documents/multiple', {
      method: 'POST',
      body: formData,
      headers: otherData,
    })
      .then((response) => {
        if (response.ok) {
          return response.json(); // Return the blob promise
        } else {
          setDisabled(false);
          setLoader(false);
          throw new Error('Response was not ok.');
        }
      })
      .then((jsonData) => {
        console.log(jsonData, 'jsonData'); // Handle the blob data here
        if (jsonData.responseCode == 200) {
          setTimeout(() => {
            // After AJAX success, navigate to the About page
            navigate('/listing');
          }, 1000);
        } else {
          setDisabled(false);
          setLoader(false);
          showErrorNotification(jsonData.responseMessage);
        }
      })
      .catch((error) => {
        setLoader(false);
        setDisabled(false);
        showErrorNotification(error.message);
        // throw new Error("Network response was not ok.");
        // console.error("Fetch error:", error);
      });
  };

  const handleFileUpload = () => {
    setLoader(true);
    setTableData(() => []);
    if (file) {
      console.log(file, formData, '..........');
      showInfoNotification('Task is processing...');
      uploadData(file, formData);
      //Object.values(file).map((item, key) => callBlobDownload(item, key));
    } else {
      if (!file) showInfoNotification('No file Found');
      else showInfoNotification('No image found');
    }
  };

  const handleSearchTypeChange = (event) => {
    if (event.target.value) {
      const selectedIndex = event.target.selectedIndex;
      const selectedText = event.target.options[selectedIndex].text;
      setSelectTypeText(selectedText);
      setSelectTypeValue(event.target.value);
    } else {
      setSelectTypeText('');
      setSelectTypeValue('');
    }
  };
  return (
    <>
      <div className="my_form_div col">
        <Form>
          <div className="row">
            <div className="col-md-12">
              <label htmlFor="name">
                Name<span className="red">*</span>
              </label>
              <Input
                name="name"
                type="text"
                maxLength={100}
                onChange={handleInputChange}
                onKeyDown={handleKeyPress}
                placeholder="Enter the Name"
              />
            </div>
            <div className="col-md-12">
              <label htmlFor="email">
                Email<span className="red">*</span>
              </label>
              <Input
                name="email"
                type="text"
                maxLength={100}
                onChange={handleInputChange}
                onKeyDown={handleKeyPress}
                placeholder="Enter the Email"
              />
            </div>
            <div className="col-md-12">
              <label htmlFor="mobile">
                Mobile<span className="red">*</span>
              </label>
              <Input
                name="mobile"
                type="text"
                maxLength={10}
                onKeyDown={handleKeyPress}
                onChange={handleInputChange}
                placeholder="Enter the Mobile"
              />
            </div>
            <div className="col-md-12">
              <label htmlFor="mobile">
                Please Select
                {/* <span className="red">*</span> */}
              </label>
              <select value={selectTypeValue} onChange={handleSearchTypeChange}>
                <option value="">Select</option>
                <option value="orderNo">Order No</option>
                <option value="sellBillNo">Sell Bill No</option>
              </select>
            </div>
          </div>
          {selectTypeText ? (
            <div className="row">
              <div className="col-md-12">
                <label htmlFor="mobile">
                  Enter {selectTypeText}
                  {/* <span className="red">*</span> */}
                </label>
                <Input type="text" maxLength={100} onKeyDown={handleKeyPress} onChange={handleInputChange} name="lead_number" />
              </div>
            </div>
          ) : (
            ''
          )}
          <div className="row">
            <div className="col-md-12">
              <label htmlFor="myFile">
                Upload Files<span className="red">*</span>
              </label>
              <div className="file-input-container">
                <Input id="myFile" name="myFile" type="file" onChange={handleFileChange} multiple placeholder="upload multiple images" />
                <label htmlFor="myFile">Upload Files</label>
              </div>
              {uploadedFiles?.length > 0 && (
                <ul className="doclistaction">
                  <h3>Uploaded Files</h3>
                  {uploadedFiles.map((fileName, index) => (
                    <li key={index}>
                      {fileName}
                      <Button type="link" onClick={() => handleRemoveFile(index)} className="remove">
                        Remove
                      </Button>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
          <label className="text-bold-q">Quality: </label>
          <div className="form-check form-check-inline">
            <label>
              <input
                type="radio"
                checked={quality === 'low'}
                name="quality"
                value={'low'}
                className="form-check-input"
                onChange={() => setQuality('low')}
              />
              Low
            </label>
          </div>
          <div className="form-check form-check-inline">
            <label>
              <input
                type="radio"
                checked={quality === 'medium'}
                name="quality"
                value={'medium'}
                className="form-check-input"
                onChange={() => setQuality('medium')}
              />
              Medium
            </label>
          </div>
          <div className="form-check form-check-inline">
            <label>
              <input
                type="radio"
                checked={quality === 'high'}
                name="quality"
                value={'high'}
                className="form-check-input"
                onChange={() => setQuality('high')}
              />
              High
            </label>
          </div>
          <Button onClick={handleFileUpload} disabled={disabled} className="btn btn-primary">
            Submit Documents
          </Button>
        </Form>
      </div>

      {loader && <Loader />}
    </>
  );
};

export default UploadDocumentForm;
